import _SvgIcon from "@material-ui/core/esm/SvgIcon";
import React from 'react';
import { variables } from 'swag-client-common/styles/variables-js';
export const FilterProductsListingIcon = ({
  svgColor = variables.colorWhite,
  className
}) => /*#__PURE__*/React.createElement(_SvgIcon, {
  viewBox: "0 0 64 64",
  x: "0px",
  y: "0px",
  className: className
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: svgColor,
  d: "M34,37.2V0h-4v37.2c-4.6,0.9-8,5-8,9.8s3.4,8.9,8,9.8V64h4v-7.2c4.6-0.9,8-5,8-9.8S38.6,38.1,34,37.2z M32,53 c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S35.3,53,32,53z"
}), /*#__PURE__*/React.createElement("path", {
  fill: svgColor,
  d: "M62,25c0-4.8-3.4-8.9-8-9.8V0h-4v15.2c-4.6,0.9-8,5-8,9.8s3.4,8.9,8,9.8V64h4V34.8C58.6,33.9,62,29.8,62,25z M52,31 c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S55.3,31,52,31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: svgColor,
  d: "M22,18c0-4.8-3.4-8.9-8-9.8V0h-4v8.2c-4.6,0.9-8,5-8,9.8s3.4,8.9,8,9.8V64h4V27.8C18.6,26.9,22,22.8,22,18z M12,24 c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S15.3,24,12,24z"
})));